import { AssetReoModel, LiabilityModel } from '../../../../models/asset-liabilities.model';

export class ReoGridModel extends AssetReoModel {
  index: number;
  applicationId: number;
  liabilityName: string;
}

export class LiabilityModelV2 extends LiabilityModel {
  liabilityTooltip?: string;
  lienPositionTooltip?: string;
  unpaidBalanceTooltip?: string;
  pAndITooltip?: string;

  liabilityStrikeOut?: boolean;
  lienPositionStrikeOut?: boolean;
  unpaidBalanceStrikeOut?: boolean;
  pAndIStrikeOut?: boolean;
}

export class AssetReoModelV2 extends AssetReoModel {
  totalPaymentTooltip?: string;
  marketValueTooltip?: string;
  totalPaymentStrikeOut?: boolean;
  marketValueStrikeOut?: boolean;
  _hideAndIgnoreNRI?: boolean;
  totalPayment?: number;
  _NRI: number;
  linkedLiabilities: LiabilityModelV2[];
}
